import styled from 'styled-components'

import { Spacings, Text } from '@styles'

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding: ${Spacings.SPACING_2B} ${Spacings.SPACING_3B};
	background: ${({ theme }) => theme.palette.background.blueLightest};
	border-radius: ${Spacings.SPACING_2B};
`

const LineWrapper = styled.span`
	font-size: ${({ uppercase }) => (uppercase ? Text.SMALL : Text.MEDIUM)};
	display: inline-block;
	color: ${({ theme }) => theme.palette.text.darkblack};
	margin-bottom: ${({ marginBottom }) => (marginBottom ? Spacings.SPACING_1B : 0)};
    margin-top:${({ marginTop }) => (marginTop ? Spacings.SPACING_2B : 0)}
	text-transform: ${({ uppercase }) => (uppercase ? 'uppercase' : '')};
	font-weight: ${({ uppercase }) => (uppercase ? '600' : '500')};
`

const NoAddressMessage = styled.div`
	padding: ${Spacings.SPACING_3B} 0;
	text-align: center;
	font-size: ${Text.MEDIUM};
	font-weight: ${Text.BOLD_600};
	color: ${({ theme }) => theme.palette.text.label};
`

export const Header = styled.div`
	margin: 0 0 ${Spacings.SPACING_2B} 0;
	border-bottom: ${({ theme, noBorder }) => (noBorder ? 'none' : `1px solid ${theme.palette.background.searchgrey}`)};
`

const ProbeAddressCard = ({ data, heading }) => {
	if (!data?.address_line1 && !data?.address_line2) {
		return (
			<Wrapper>
				<Header>{heading}</Header>
				<NoAddressMessage>No Address Present</NoAddressMessage>
			</Wrapper>
		)
	}

	return (
		<>
			<Wrapper>
				<Header>{heading}</Header>
				{data?.address_line1 && <LineWrapper marginBottom>{data?.address_line1}</LineWrapper>}
				{data?.address_line2 && <LineWrapper marginBottom>{data?.address_line2}</LineWrapper>}
				<div>
					<LineWrapper uppercase marginTop>
						{data?.state},&#160;
					</LineWrapper>
					<LineWrapper uppercase>{data?.city}&#160;-&#160;</LineWrapper>
					<LineWrapper uppercase>{data?.pincode}</LineWrapper>
				</div>
			</Wrapper>
		</>
	)
}

export default ProbeAddressCard
